<template>
  <v-card class="mt-2 ml-2 mr-2">
      <FtObjectTable class="pl-2 pr-2"/>
  </v-card>
</template>

<script>
import FtObjectTable from "@/components/admin-umkm-object/FUmkmTable.vue";

export default {
  name: "DaftarObjectView",
  components: {
    FtObjectTable
  },
  data() {
    return {
      tabTitle: 'DaftarObject'
    }
  },
  computed: {
  },
  methods: {

  },


}
</script>

<style scoped>
</style>